import { render, staticRenderFns } from "./simOpen19.vue?vue&type=template&id=8d52dff2&scoped=true&"
import script from "./simOpen19.vue?vue&type=script&lang=js&"
export * from "./simOpen19.vue?vue&type=script&lang=js&"
import style0 from "./simOpen19.vue?vue&type=style&index=0&id=8d52dff2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d52dff2",
  null
  
)

export default component.exports